const links = [
  {
    label: "Github",
    url: "https://github.com/renatorocha1/",
  },
  {
    label: "Linkedin",
    url: "https://www.linkedin.com/in/renatorocha1",
  },
  {
    label: "Behance",
    url: "https://www.behance.net/renatorocha3",
  },
]

export default links
